import { createFileRoute, redirect } from "@tanstack/react-router"

// Redirect shim: /register was renamed to /signup. Kept so external links
// (e.g. the marketing site) keep working.
export const Route = createFileRoute("/(redirects)/register")({
  component: () => null,
  beforeLoad: async () => {
    throw redirect({
      to: "/signup",
      search: (search) => search, // forward all search params
    })
  },
})
